module.exports = __webpack_public_path__ + "img/great-commitments-lockup-white.e82ebe5e.png";